export const formatCurrency = function(num) {
  return parseFloat(num)
    .toFixed(0)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
};
